import { gql } from '@apollo/client'

/* eslint-disable import/prefer-default-export */
export const GET_ORACLE_ACCESS = gql`
  query GetOracleAccess(
    $titleGroupIds: [String]!
    $language: [String]!
  ) {
    contentList(
      where: {
        titleGroupId: { in: $titleGroupIds }
      }
      language: $language
    ) {
      content {
        id
        titleGroupId
        contentPolicy {
          accessCheck {
            allowed
          }
        }
      }
    }
  }
`
